<kui-modal [title]="data.title" [actions]="modalActions" (onClose)="closeModal()">
    <div class="p-3">
        @if (data) {
            <key-form-builder [form]="data.form" [values]="data.values"></key-form-builder>
        }
    </div>
</kui-modal>
